import { cn } from '@/utils/cn'
import type { TaskExecutor } from '@/components/Configuracao/esforcoTimeTypes'

type Props = {
  open: boolean
  isEdit: boolean
  modalTask: string
  modalHours: string
  modalExecutor: TaskExecutor
  onClose: () => void
  onSave: () => void
  onTaskChange: (v: string) => void
  onHoursChange: (v: string) => void
  onExecutorChange: (v: TaskExecutor) => void
}

export function EsforcoTimeTaskModal({
  open,
  isEdit,
  modalTask,
  modalHours,
  modalExecutor,
  onClose,
  onSave,
  onTaskChange,
  onHoursChange,
  onExecutorChange,
}: Props) {
  if (!open) return null

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-background-dark border border-white/[0.08] w-full max-w-md rounded-xl p-5 space-y-4 shadow-2xl">
        <h3 className="text-text-primary font-bold text-sm">{isEdit ? 'Editar Tarefa' : 'Adicionar Nova Tarefa'}</h3>

        <div className="space-y-3">
          <div className="flex flex-col gap-1.5">
            <label className="text-text-muted text-[10px] font-bold uppercase tracking-wider">Nome da Tarefa</label>
            <input
              type="text"
              value={modalTask}
              onChange={(e) => onTaskChange(e.target.value)}
              placeholder="Ex: Criação de Banner"
              className="bg-white/[0.04] border border-white/[0.06] text-text-primary rounded-md px-3 py-2 text-xs outline-none focus:border-accent transition-colors"
            />
          </div>

          <div className="flex flex-col gap-1.5">
            <label className="text-text-muted text-[10px] font-bold uppercase tracking-wider">
              Tempo Estimado (hh:mm:ss)
            </label>
            <input
              type="text"
              value={modalHours}
              onChange={(e) => onHoursChange(e.target.value)}
              placeholder="01:30:00"
              className="bg-white/[0.04] border border-white/[0.06] text-text-primary rounded-md px-3 py-2 text-xs font-mono outline-none focus:border-accent transition-colors"
            />
          </div>

          <div className="flex flex-col gap-1.5">
            <label className="text-text-muted text-[10px] font-bold uppercase tracking-wider">Executor</label>
            <div className="flex gap-2">
              {(['Equipe', 'Gerencia'] as const).map((exec) => (
                <button
                  key={exec}
                  type="button"
                  onClick={() => onExecutorChange(exec)}
                  className={cn(
                    'flex-1 py-2 text-xs font-semibold rounded-md border transition-all',
                    modalExecutor === exec
                      ? 'border-accent bg-accent/10 text-accent'
                      : 'border-white/[0.06] bg-white/[0.02] text-text-muted hover:text-text-primary',
                  )}
                >
                  {exec}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end gap-2 pt-2">
          <button
            type="button"
            onClick={onClose}
            className="px-3 py-1.5 rounded-md text-xs font-bold text-text-muted hover:text-text-primary hover:bg-white/[0.06] transition-all min-h-[44px]"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={onSave}
            disabled={!modalTask}
            className="px-4 py-1.5 rounded-md text-xs font-bold bg-accent text-white shadow-lg shadow-accent/20 hover:bg-accent/90 transition-all min-h-[44px] disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Salvar
          </button>
        </div>
      </div>
    </div>
  )
}
